import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { TransportService } from 'src/app/api/tourism/transport.service';
import { GeneralService } from 'src/app/api/config/general.service';
import { VehicletypeExtendsComponent } from 'src/app/config/vehicletype/vehicletype-extends/vehicletype-extends.component';

@Component({
  selector: 'app-transport-form',
  templateUrl: './transport-form.component.html',
  styleUrls: ['./transport-form.component.css']
})
export class TransportFormComponent implements OnInit {

  @ViewChild(VehicletypeExtendsComponent) VehicletypeExtendsComponent: any;

  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables
  vehicletypes: any = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private generalService: GeneralService,
    private transportService: TransportService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      owner: [null, [Validators.required, Validators.minLength(2)]],
      document: [null, [Validators.required, Validators.minLength(2)]],
      capacity: [null, [Validators.required]],
      vehicletype_id: [null],
      vehicle_type: [null, [Validators.required]],
      license_plate: [null],
      reference_name: [null],
      cellphone: [null],
      telephone: [null],
      email: [null],
      address: [null],
      characteristic: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.route);
    this.getVehicleType();
    if (this.isEdit) {
      this.editData();
    }
  }
  editData() {
    this.transportService.get(this.checkId).subscribe({
      next: (data: any) => {
        let item_ = data.data;
        this.item.patchValue({
          owner: item_.owner,
          document: item_.document,
          capacity: item_.capacity,
          vehicletype_id: item_.vehicletype_id,
          vehicle_type: item_.vehicle_type,
          license_plate: item_.license_plate,
          reference_name: item_.reference_name,
          cellphone: item_.cellphone,
          telephone: item_.telephone,
          email: item_.email,
          address: item_.address,
          characteristic: item_.characteristic
        });
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  getVehicleType() {
    this.generalService.listVehicleType().subscribe({
      next: (data: any) => {
        this.vehicletypes = data.results;
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    if (this.validate()) {
      if (this.isEdit) {
        this.transportService.update(this.checkId, this.item.value).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.transportService.save(this.item.value).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    return true;
  }

  cancel() {
    this.router.navigate([
      this.branchofficeSlug + '/turismo/transportes/lista'
    ]);
  }

  extendsVehicleType(event: any): void {
    this.getVehicleType();
    this.item.patchValue({
      vehicletype_id: event.id
    });
  }
};
